<template>
    <div 
        class="product-card" 
        :class="{ hovered: isHovered }" 
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        @click="handleClick"
    >
        <div class="product-header">
            <div class="product-title">{{ product.Name }}</div>
            <div class="product-price">${{ product.Price || 0 }}</div>
        </div>
        <ul class="feature-list">
            <li v-for="description in product.Description" :key="description">{{ description }}</li>
        </ul>
        <button v-if="isHovered && product.Price !== 0" class="buy-btn" @click.stop="handlePurchase">
            {{ $i18n.t("subscription.btn_product_page_card_buy") }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'ProductCard',
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isHovered: false
        };
    },
    methods: {
        handleMouseEnter() {
            this.isHovered = true;
        },
        handleMouseLeave() {
            this.isHovered = false;
        },
        handleClick() {
            // 保留点击事件，如果需要的话
            this.$emit('click', this.product);
        },
        handlePurchase() {
            this.$emit('purchase', this.product);
        }
    }
}
</script>

<style scoped>
.product-card {
    background: white;
    border-radius: 15px;
    padding: 10px 15px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.product-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.product-card.hovered {
    border: 1.5px solid #667eea;
    transform: translateY(-10px);
}

.product-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: linear-gradient(90deg, #667eea, #764ba2);
}

.product-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    gap: 15px;
}

/* 当宽度大于480px时，改为垂直布局 */
@media (min-width: 481px) {
    .product-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
}

.product-title {
    font-size: 15px;
    font-weight: bold;
    color: #2c3e50;
    flex: 1;
    min-width: 0;
}

.product-price {
    font-size: 24px;
    font-weight: bold;
    color: #28a745;
    white-space: nowrap;
}

.feature-list {
    list-style: none;
    margin-bottom: 8px;
    padding: 0;
}

.feature-list li {
    padding: 5px 0;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 20px;
    font-size: 13px;
}

.feature-list li::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #27ae60;
    font-weight: bold;
}

.buy-btn {
    background: linear-gradient(45deg, #667eea, #764ba2);
    color: white;
    border: none;
    padding: 10px 30px;
    border-radius: 25px;
    font-size: 14px;
    cursor: pointer;
    width: 100%;
    transition: all 0.2s;
    opacity: 0;
    transform: translateY(20px);
}

.product-card.hovered .buy-btn {
    opacity: 1;
    transform: translateY(0);
}

.buy-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}
</style>